module.exports = __webpack_public_path__ + "img/Vespaio-Map-icon-White@2x.5e1ecdb6.png";